export enum GeneralSettingsFormTestIds {
  BLOCK_CREATE_ORDER_WITHOUT_CUSTOMER_SWITCH = 'general-settings.block-create-order-without-customer-switch',
  ALLOW_REPRESENTATIVES_TO_INVITE_CUSTOMERS_SWITCH = 'switch_general_settings_allow_representatives_to_invite_customers',
  ALLOW_BLOCKED_CUSTOMER_TO_CREATE_ORDER_SWITCH = 'allow_blocked_customer_to_create_order',
  ALLOW_APPROVE_ORDER_FOR_BLOCKED_CUSTOMER_SWITCH = 'allow_approve_order_for_blocked_customer',
}
